import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './root-reducer';
import moduleMiddlewares from './middlewares';
import config from '../global/env.config';
export let store = undefined;
export const configureStore = (appThunkContext = {}) => {
    const middlewares = [
        thunk.withExtraArgument(appThunkContext),
        ...moduleMiddlewares,
    ];
    let composeEnhancers = compose;
    // adds logger and Redux DevTools for non-production environments
    if (config.env !== 'production') {
        middlewares.push(createLogger({ collapsed: true }));
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?? compose;
    }
    store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middlewares)));
    return store;
};
